import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AppConfigService } from '../../services/app-config.service';

@Component({
  selector: 'app-development',
  standalone: true,
  imports: [],
  templateUrl: './development.component.html',
  styleUrl: './development.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DevelopmentComponent implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);
  appData = inject(AppConfigService);

  ngOnInit(): void {
    console.log(this.appData);

    this.title.setTitle('Página web en desarrollo | ' + this.appData.title);
    this.meta.updateTag({
      name: 'description',
      content:
        'Página web en desarrollo. Estamos trabajando para ofrecerte la mejor experiencia.',
    });

    this.meta.updateTag({
      name: 'og:title',
      content: 'Página web en desarrollo',
    });

    this.meta.updateTag({
      name: 'keywords',
      content:
        'Asesoría fiscal, contable y laboral, asesoría jurídica, asesoría financiera, auditoría, consultoría empresarial, servicios de outsourcing, asesoría en tecnología y transformación digital, asesoría en recursos humanos, asesoría en comercio internacional, asesoría en gestión de riesgos',
    });
  }
}
